import React from 'react';
import { RootineTabs } from '../../../atoms';
import { colors, theme } from '../../../utils/theme';
import { BloodRecommendations } from '../BloodVitaminInsights';
import { Box } from '@mui/material';
import { BloodInsightRecommendationDetails } from '../../../types';

export const BloodImprovementPlan = ({
  recommendations,
}: {
  recommendations: BloodInsightRecommendationDetails[];
}): JSX.Element => {
  return (
    <RootineTabs
      tabs={{
        'Improvement Plan': (
          <Box display="flex" flexDirection="column" sx={{ mt: 3 }}>
            <BloodRecommendations recommendations={recommendations} />
          </Box>
        ),
        '': <></>,
      }}
      hideTabs={false}
      tabsProps={{
        centered: false,
        variant: 'fullWidth',
      }}
      tabProps={{
        sx: {
          fontSize: { xs: 16, md: 18 },
          textTransform: 'none',
          color: colors.greys.GREY_550,
          fontWeight: theme.typography.light,
          '&.Mui-selected': {
            color: colors.greys.TEXT_BLACK,
            fontWeight: theme.typography.medium,
          },
        },
        disabled: true,
      }}
    />
  );
};
